exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".question-section{display:flex;flex-direction:column;gap:24px;width:100%}.question-add-header{display:flex;flex-direction:column;width:100%;gap:8px}", ""]);

// exports
